import { BrowserRouter as Router } from "react-router";
import { AppRoutes } from "@/config/routes";

export default function RouterProvider() {
  const routerBase =
    import.meta.env.BASE_URL === "/" ? undefined : import.meta.env.BASE_URL.replace(/\/$/, "");

  return (
    <Router basename={routerBase}>
      <AppRoutes />
    </Router>
  );
}
